/**
 * Formats minutes as hours with "Std." suffix.
 * Returns "—" for zero or negative values.
 * Example: 75 → "1.25 Std.", 90 → "1.5 Std.", 120 → "2 Std."
 */
export function formatArbeitszeit(minutes: number): string {
  if (minutes <= 0) return "—";
  const hours = minutes / 60;
  return `${parseFloat(hours.toFixed(2))} Std.`;
}

/**
 * Formats travel and departure durations as "Xmin/ Ymin".
 * Returns "—" if both values are zero or negative.
 */
export function formatAnfahrtAbfahrt(travelMinutes: number, departureMinutes: number): string {
  if (travelMinutes <= 0 && departureMinutes <= 0) return "—";
  return `${travelMinutes}min/ ${departureMinutes}min`;
}

/**
 * Formats Soll/Ist row: "{travel}min / {work} Std. / {departure}min".
 * Returns "—" when all three values are null/undefined/≤0.
 */
export function formatSollIst(
  travel: number | null | undefined,
  work: number | null | undefined,
  departure: number | null | undefined,
): string {
  const t = travel ?? 0;
  const w = work ?? 0;
  const d = departure ?? 0;
  if (t <= 0 && w <= 0 && d <= 0) return "—";
  const workHours = parseFloat((w / 60).toFixed(2));
  return `${t}min / ${workHours} Std. / ${d}min`;
}

/**
 * Parses "X Stunden …" strings from Immotion infoText (e.g. "2 Stunden Mittelwert")
 * and returns the duration in minutes. Returns null for null/empty/unrecognised input.
 */
export function parseStundenToMinutes(input: string | null | undefined): number | null {
  if (!input) return null;
  const match = input.match(/(\d+(?:[.,]\d+)?)\s*Stunden/i);
  if (!match) return null;
  const hours = parseFloat(match[1].replace(",", "."));
  if (!Number.isFinite(hours) || hours <= 0) return null;
  return Math.round(hours * 60);
}
